/* eslint-disable react/no-danger */
/* eslint-disable import/no-unresolved */
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import userDetail from 'Stores/userDetail';
import * as CONSTANTS from 'Utils/constants';
import { Utils } from 'Utils/utils';
import TimerWithCrown from 'Assets/png/timerWithCrown.png';
import { CommonPopupWithImageComponent } from 'Components/common/commonPopupWithImageComponent';

const UpgradeCreditPopup = observer(props => {
  const { showUpgradeCreditPopup } = userDetail;

  const [animatePopup, setAnimatePopup] = useState(false);

  const handleClickOutsidePopup = () => {
    setAnimatePopup(true);
    setTimeout(() => {
      setAnimatePopup(false);
    }, 1000);
  };
  const handleUpgradeClick = () => {
    Utils.mixpanelTrack(
      CONSTANTS.MX_TRIAL_ONBOARDING.CLICK_LB_TRIAL_UPGRADE_NOW,
      { clickPosition: 'credit_exhausted_popup' },
    );
    userDetail.setShowUpgradeCreditPopup(false);
    Utils.upgradeNowClick('credit_exhausted_popup');
  };
  const handleCloseClick = () => {
    userDetail.setShowUpgradeCreditPopup(false);
  };

  const description = (
    <>
      Your contact selection exceeds credits remaining in your account! <br />
      You can choose to purchase additional contacts now. <br />
      <b> Our plans start at &lt;$1/day!</b>
    </>
  );

  return showUpgradeCreditPopup ? (
    <CommonPopupWithImageComponent
      ImgComponent={TimerWithCrown}
      titleText="Ready for Primetime!"
      description={description}
      btnText="Upgrade Now"
      customParentClass="credit-upgrade-popup"
      customClass={animatePopup ? 'wiggle' : ''}
      actionBtnCallback={handleUpgradeClick}
      clickOutsidePopupCallback={handleClickOutsidePopup}
      closeClickCallback={handleCloseClick}
      showCloseBtn
    />
  ) : (
    ''
  );
});

export { UpgradeCreditPopup };
export default UpgradeCreditPopup;
